import React, { useState } from "react";
import "../css/searchbox.css";
import SearchIcon from "../images/search-icon.svg";

const SearchBox = () => {
  const [searchValue, setSearchValue] = useState("");
  return (
    <div className="search-box">
      <input
        type="text"
        value={searchValue}
        placeholder="Search for anything"
        onChange={(e) => setSearchValue(e.target.value)}
      />
      <img src={SearchIcon} className="search-icon" alt="" />
    </div>
  );
};

export default SearchBox;
